import { motion } from "framer-motion";
import handelsbankenLogo from "@/assets/handelsbanken-logo.webp";

/**
 * Verifierade kunder — 10 av de mest kända bolagen ur vår kundlista.
 * Loggor hämtas via Logo.dev, med möjlighet att override:a per bolag.
 */
const CLIENTS: { name: string; domain: string; logo?: string; scale?: number }[] = [
  { name: "IKEA", domain: "ikea.com" },
  { name: "Skanska", domain: "skanska.se" },
  { name: "PEAB", domain: "peab.se" },
  { name: "Vasakronan", domain: "vasakronan.se", scale: 0.6 },
  { name: "Handelsbanken", domain: "handelsbanken.se", logo: handelsbankenLogo },
  { name: "Swedbank", domain: "swedbank.se" },
  { name: "Apple", domain: "apple.com", scale: 0.6 },
  { name: "Scania", domain: "scania.com", scale: 0.6 },
  { name: "ABB", domain: "abb.com" },
  { name: "Volkswagen", domain: "volkswagen.se", scale: 0.7 },
];

const LOGO_TOKEN = import.meta.env.VITE_LOVABLE_CONNECTOR_LOGO_DEV_API_KEY;

export function ClientLogoMarquee() {
  const loop = [...CLIENTS, ...CLIENTS];
  return (
    <section
      aria-label="Verifierade kunder"
      className="relative bg-background border-y border-foreground/10 py-10 md:py-14 overflow-hidden"
    >
      <div className="mx-auto max-w-7xl px-5 md:px-10 mb-8">
        <p className="text-center font-mono text-[10px] md:text-[11px] uppercase tracking-[0.3em] text-foreground/55">
          Förtroende från fastighetsbolag, kontor, butiker & privatpersoner
        </p>
      </div>

      <ul className="sr-only">
        {CLIENTS.map((c) => (
          <li key={c.name}>{c.name}</li>
        ))}
      </ul>

      <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-background to-transparent z-10" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-background to-transparent z-10" />

      <motion.div
        aria-hidden
        className="flex gap-10 md:gap-12 whitespace-nowrap items-center"
        animate={{ x: ["0%", "-50%"] }}
        transition={{ duration: 50, ease: "linear", repeat: Infinity }}
      >
        {loop.map((c, i) => (
          <div
            key={`${c.name}-${i}`}
            className="inline-flex items-center gap-10 md:gap-12 shrink-0"
          >
            <div className="flex h-20 w-48 shrink-0 items-center justify-center md:h-24 md:w-60">
              <img
                src={c.logo ?? `https://img.logo.dev/${c.domain}?token=${LOGO_TOKEN}&size=140&format=png&theme=light`}
                alt={`${c.name} logotyp`}
                width={140}
                height={56}
                loading="lazy"
                decoding="async"
                style={{ transform: `scale(${c.scale ?? 1})` }}
                className="max-h-full max-w-full object-contain transition-transform"
              />
            </div>
            <span className="text-gold/50 text-base">◆</span>
          </div>
        ))}
      </motion.div>
    </section>
  );
}
